// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 90%;
  margin: 15px auto;
}

.title {
  font-family: AppFontSemiBold, sans-serif;
  margin-top: 15px;
  font-size: 22px;
  text-align: center;
  color: #000000;
}

ion-item {
  border: 1px solid #e5e5e5;
  border-radius: 0px;
  font-size: 16px !important;
  color: black;
  --background: white;
}
ion-item ion-label {
  margin-left: 10px;
  margin-right: 8px;
}

.btn {
  width: 100%;
  height: 54px;
  outline: var(--outline-default);
  background: var(--ion-color-primary);
  border-radius: var(--radius-default);
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 991px) {
  .btn {
    height: 67px;
  }
}
.btn span {
  font-family: AppFont;
  color: #1D1D1B;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.2px;
  letter-spacing: 0.01em;
}

ion-icon {
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/app/components/add-custom-tip/add-custom-tip.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,UAAA;EACA,iBAAA;AADD;;AAGA;EACC,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAAD;;AAGA;EACC,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;AAAD;AACC;EACC,iBAAA;EACA,iBAAA;AACF;;AAEA;EACC,WAAA;EACA,YAAA;EACA,+BAAA;EACG,oCAAA;EACH,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACD;ACjCE;EDwBF;IAWE,YAAA;EAEA;AACF;AAAC;EACC,oBAAA;EACA,cAAA;EACA,eAAA;EACM,gBAAA;EACN,mBAAA;EACA,sBAAA;AAEF;;AACA;EACC,WAAA;AAED","sourcesContent":["@use \"../../../theme/mixins\" as *;\n\n.wrapper {\n\twidth: 90%;\n\tmargin: 15px auto;\n}\n.title {\n\tfont-family: AppFontSemiBold, sans-serif;\n\tmargin-top: 15px;\n\tfont-size: 22px;\n\ttext-align: center;\n\tcolor: #000000;\n}\n\nion-item {\n\tborder: 1px solid #e5e5e5;\n\tborder-radius: 0px;\n\tfont-size: 16px !important;\n\tcolor: black;\n\t--background: white;\n\tion-label {\n\t\tmargin-left: 10px;\n\t\tmargin-right: 8px;\n\t}\n}\n.btn {\n\twidth: 100%;\n\theight: 54px;\n\toutline: var(--outline-default);\n    background: var(--ion-color-primary);\n\tborder-radius: var(--radius-default);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\t@include desktop {\n\t\theight: 67px;\n\t}\n\n\tspan {\n\t\tfont-family: AppFont;\n\t\tcolor: #1D1D1B;\n\t\tfont-size: 14px;\n        font-weight: 400;\n\t\tline-height: 19.2px;\n\t\tletter-spacing: 0.01em;\n\t}\n}\nion-icon {\n\tz-index: 10;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
